// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Import Rails UJS for data-confirm, data-disable-with, and other Rails helpers
import Rails from "@rails/ujs";
Rails.start();

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import { Popover } from "bootstrap";

document.addEventListener("DOMContentLoaded", () => {
  // document.querySelectorAll(".carousel").forEach((el) => {
  //   if (!el.Carousel) {
  //     el.Carousel = new BootstrapNative.Carousel(el);
  //   }
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popover) => {
    new Popover(popover);
  });
});

import React from "react";
import ReactDOM from "react-dom";
import { mountComponents } from "react-rails-ujs";

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import "../../javascript/src/styles/global/index.scss";
import "../../javascript/src/lib/fontawesome";

import AddressForm from "@components/AddressForm";
import JobBenchmarks from "@components/JobBenchmarks";
// import FeedbackComponent from '@components/FeedbackComponent';
import SearchComponent from "@components/SearchComponent";
// import LearnCalculator from "@components/LearnCalculator";
import HomepageDashboard from "@components/HomepageDashboard";
import PersonalGreeting from "@components/PersonalGreeting";
// import GetStartedProgress from "@components/GetStartedProgress";
import PageNavSelect from "@components/PageNavSelect";

mountComponents({
  AddressForm,
  JobBenchmarks,
  // FeedbackComponent,
  SearchComponent,
  // LearnCalculator,
  HomepageDashboard,
  PersonalGreeting,
  // GetStartedProgress,
  PageNavSelect,
});
